
export enum ProcessExitStatus {
    ProcessExitedSuccessfully = "processExitedSuccessfully",
}

export enum ProcessingStatus {
    InProgress = "inProgress",
    Inactive = "inactive",
    ChunkCreationStopped = "chunkCreationStopped",
}

export interface ProcessorOptions {
    array: any[],
    fn: Function,
    maxTimePerChunk?: number,
}

export class LongArrayProcessingWorker extends EventTarget {
    constructor() {
        super();

        this._currentTime = this._currentTime.bind(this);
        this._doChunk = this._doChunk.bind(this);
        this._cleanUpAndReset = this._cleanUpAndReset.bind(this);
    }

    get status() {
        if (this._isProcessing) {
            return ProcessingStatus.InProgress;
        } else {
            return ProcessingStatus.Inactive;
        }
    }

    get statusPercent() {
        const percent = (this._currentItemIndex / this._arrayToProcess.length-1) * 100;
        return percent;
    }

    async startProcessing(options: ProcessorOptions) {
        const { array, fn, maxTimePerChunk } = options;
        if (!array.length) {
            return;
        }

        if (this._isProcessing) {
            console.error("Processing currently in-progress. Exit current process to start a new one - finished: ", this.statusPercent, "%")
            return;
        }
        this._isProcessing = true;
        this._arrayToProcess = array;
        this._processFunction = fn;
        if (maxTimePerChunk) {
            this._maxTimePerChunk = maxTimePerChunk;
        }

        this._currentItemIndex = 0;

        this._doChunk();
    }

    async stopProcessing() {
        if (!this._isProcessing) {
            return;
        }
        this._stopCurrentProcessing = true;

        // Keep checking for the final closing signal i.e. process is cleaned up and closed
        while (this.status !== ProcessingStatus.Inactive) {
            await new Promise(resolve => setTimeout(resolve, 50));
        }

        return ProcessExitStatus.ProcessExitedSuccessfully;
    }

    private _arrayToProcess: any[] = [];
    private _processFunction: Function = () => {};
    private _maxTimePerChunk: number = 50;
    private _currentItemIndex: number = 0;
    private _currentTimeouts: number[] = [];
    private _isProcessing: boolean = false;
    private _stopCurrentProcessing: boolean = false;

    private _cleanUpAndReset() {
        for (let i = 0; i < this._currentTimeouts.length; i++) {
            clearTimeout(this._currentTimeouts[i]);
        }
        this._isProcessing = false;
        this._stopCurrentProcessing = false;
    }

    private _currentTime(): number {
        return new Date().getTime();
    }

    private _doChunk() {
        const startTime = this._currentTime();

        while (this._currentItemIndex < this._arrayToProcess.length && (this._currentTime() - startTime) <= this._maxTimePerChunk) {
            
            // exit message recieved, so close process
            if (this._stopCurrentProcessing) {
                this._cleanUpAndReset();
                return;
            }

            // callback called with args (value, index, array)
            this._processFunction.call(this, this._arrayToProcess[this._currentItemIndex], this._currentItemIndex, this._arrayToProcess);
            
            // all functions has been executed, so process can be closed
            if (this._currentItemIndex >= this._arrayToProcess.length-1) {
                this._cleanUpAndReset();
                return;
            }

            this._currentItemIndex++;
        }

        if (this._currentItemIndex < this._arrayToProcess.length) {
            // set Timeout for async iteration
            this._currentTimeouts.push(setTimeout(this._doChunk, 1, this));
        }
    }
}
